import React, { useState, useEffect } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import "react-toastify/dist/ReactToastify.css";

import {
  TextField,
  Button,
  Card,
  CardContent,
  Typography,
  Autocomplete,
} from "@mui/material";
import { red } from "@material-ui/core/colors";
import welcomeImage2 from "../../assets/regBackGround.jpg";
import thankYouImage from "../../assets/thankYou.jpg";
import tradefont from "../../assets/tradegothicextended.otf";
import { createTheme, ThemeProvider, CssBaseline } from "@mui/material/styles";
import { Navigate } from "react-router-dom";
// import disclaimer from '../../assets/disclaimer.json';

const disclaimer = `

                                          TERMS AND CONDITIONS

1.Entry into the Squid Game activation space is at the sole discretion of the 
  Organiser(s)
2.By processing entry to theSquid Game Activation space, either directly or through the parent or 
guardian, the Attendee(s) acknowledge and agree to abide by the Organiser’s:
a.(i)         Terms and Conditions
b.(ii)        Waiver And Release Of Liability Form
3.All participants allowed into the Squid Game activation space must register themselves at the 
entryway and wear the wrist bands given
4.Each wristband entitles entry for 1 person for 1 time only. Wristbands are not valid for multiple 
entries
5.Damaged, tampered, torn and removed wristbands will not be replaced and entry maybe denied incase 
of any misuse.
6. Organiser(s) reserve the right to reserve, withdraw and/or cancel admission without any prior notice
7.The personal information of Attendee(s)  supplied to the Organiser(s) at the time of participation 
is securely stored by the Organiser(s) as confidential information. The Organisers assure the Attendees 
that the personal information shall not be shared, exchanged or exploited for commercial gain. However, 
access to such information shall be restricted for internal analysis and assessment by the Organisers 
and used for future communications.
8.The Attendee(s) may be videographed, filmed, photographed and/or recorded for broadcast, publication, 
advertisement, marketing or security purposes whilst at the Event by the Organiser(s) or by the 
Organiser(s), sponsors and partners. The Attendee(s) hereby grant to the Organiser(s) the right to use 
in perpetuity, all or any part of the recording including but not limited to videos, films, photographs 
and/or recording of the Attendee(s) on any channel including social media channels globally for 
broadcasting, advertising, marketing, publicity and promotions.
9.Outside food, aerated and alcoholic beverages are not allowed inside the Squid Game activation space
10.The Organiser(s) or any of its agents, officers, or employees will not be responsible for any injury, 
damage, theft, losses or cost suffered by the Attendee(s)at the Squid Game activation space 
11.Medical Requirements:
a.The Attendee(s) are advised to take all necessary precautions during the Event. The Organiser(s) assumes 
no liability if Attendee(s)suffers any medical condition while attending the Event.
b.The Organiser(s) will not be responsible for any ill/harmful/negative/allergic effects of food items or 
drinks consumed at the Event by the Attendee(s).
12.The Attendee(s) will not be allowed entry at the Squid Game activation space if found in an inebriated 
state. The Organiser(s) reserves the right to evict such Attendee(s) from the arena Attendee(s) who are 
under the influence of drugs or excessive alcohol or who in the reasonable opinion of the Organiser(s)
conducts themselves in an inappropriate manner.
13.No dangerous or potentially hazardous objects including but not limited to weapons, knives, guns, 
firearms, fireworks, laser devices, glass bottles licensed or otherwise will be allowed in the Squid Game 
activation space and patrons may be asked to leave if found to be carrying any such items.
14.Vape pens, e-cigarettes, cigarettes, lighters and any other smoking devices are prohibited at the 
Event. The Organiser(s) as per its sole discretion will confiscate and dispose of any such prohibited 
items as and when found at the Event.
15.Consumption and sale of illegal and banned substances is strictly prohibited and anyone found 
consuming, selling or possessing such illegal substances will be immediately handed over to the 
appropriate authorities.
16.Attendee(s) will be given one chance per game. Re tries (if any) is at the sole discretion of the 
Organiser(s) and is not binding
17.Swag distribution is at the sole discretion of the Organiser(s) 
18.The Organiser(s) reserves the right to change or cancel any part or the full program, function, 
display, activity line up, games, promotions, scheme, announced or unannounced before or during at the 
Festival Venue without giving prior notice
19.The Organiser(s) reserves the right to conduct security searches at entry or at any time during the 
Event and confiscate any item which may cause danger or disruption to other persons or the event or is 
one of the items not permitted in the venue as listed in these Terms and Conditions.
20.The Attendee(s) shall not bring into the Squid Game Activation space or display or distribute (whether 
for free or otherwise) during the event any sponsorship, promotional or marketing materials.
21.Attendee(s) are advised not to hand over any belongings to the Organizer representatives/crew under 
any circumstances, and Organiser(s) will not be responsible for loss or damage to personal effects
22.The Organiser(s) reserves the right to ask the Attendee(s) to exit from the Squid Game activation 
space if the Attendee(s) is not following the safety guidelines of the Event, on grounds of misdemeanour, 
any other medical safety reasons or breach of these Terms etc.
23.All the Attendee(s)at the Event will be required to ensure that they cooperate with the Organiser(s)’s 
team at the Event in an ethical and a polite way.
24.The Attendee(s) will not be allowed to bring pets at the Event.
25.The Attendee(s) are not allowed to bring any backpacks/big bags/storage items to the Event and such 
bags/storage items will not be allowed into the venue. The Organiser(s) does not provide any storage 
facility at the Event Venue.
`;

const primaryThemeColor = "#ffffff";

const theme = createTheme({
  typography: {
    fontFamily: `"Trade Gothic Extended", sans-serif`,
  },
  palette: {
    text: {
      primary: primaryThemeColor,
    },
    primary: {
      main: primaryThemeColor,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: "Trade Gothic Extended";
          src: url(${tradefont}) format("opentype");
        }
        body {
          font-family: "Trade Gothic Extended", sans-serif;
        }
      `,
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: "#DF3B7D",
              borderRadius: "50px",
              textAlign: "left",
              justifyContent: "left",
            },
            "&:hover fieldset": {
              borderColor: "#DF3B7D",
            },
            "&.Mui-focused fieldset": {
              borderColor: "#DF3B7D",
            },
          },
          "& .MuiInputLabel-root": {
            color: primaryThemeColor,
          },
          "& .MuiInputLabel-root.Mui-focused": {
            color: primaryThemeColor,
          },
          "& .MuiInputBase-input": {
            color: primaryThemeColor,
            fontFamily: `"Trade Gothic Extended", sans-serif`,
          },
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        fontFamily: `"Trade Gothic Extended", sans-serif`,
        h5: {
          color: primaryThemeColor,
          fontFamily: `"Trade Gothic Extended", sans-serif`,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        contained: {
          backgroundColor: "transparent",
          color: primaryThemeColor,
          border: `1px solid pink`,
          borderRadius: "50px",
          fontFamily: `"Trade Gothic Extended", sans-serif`,
          // "&:hover": {
          //   backgroundColor: primaryThemeColor,
          //   color: "#000000",
          // },
        },
      },
    },
  },
});

const styles = {
  container: {
    // backgroundImage: `url('https://firebasestorage.googleapis.com/v0/b/tieyoung-e964a.appspot.com/o/Netflix%2FPotrait%20Register.png?alt=media')`,
    backgroundImage: `url(${welcomeImage2})`,
    backgroundColor: "#ffffff",
    backgroundSize: "cover",
    backgroundPosition: "center",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    fontFamily: `url(${tradefont})`,
    alignItems: "center",
    color: "#ffffff",
    bordercolor: "#ffffff",
  },
  card: {
    maxWidth: "75%",
    width: "90%",
    backgroundColor: "rgba(255, 255, 255, 0)",
    borderRadius: "10px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    marginTop: "-10%",
  },
  heading: {
    textAlign: "center",
    marginBottom: "20px",
    // color: "#333",
  },
  form: {
    top: "100px",
    display: "flex",
    flexDirection: "column",
    borderColor: "#DF3B7D",
    borderRadius: "20px",
    padding: "100px",
    autoComplete: "off",
  },
  button: {
    left: "28%",
    marginTop: "20px",
    padding: "10px 0",
    backgroundColor: "#DF3B7D",
    borderColor: "black",
    color: "black",
    width: "150px",
  },
};

const popupStyles = {
  container: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "block",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "red",
    color: "black",
    zIndex: 9999,
    padding: "20px",
  },
  popup: {
    // width: "100%",
    height: "85vh",
    // maxWidth: "700px",
    backgroundColor: "black",
    borderRadius: "10px",
    padding: "2%",
    overflow: "hidden",
    display: "block",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "left",
    fontSize: "11px",
  },
  button: {
    width: "125px",
    marginTop: "20px",
    marginLeft: "41%",
    padding: "10px 0",
    backgroundColor: "#DF3B7D",
    borderColor: "black",
    color: "black",
    fontSize: "12px",
  },
};

const Register = () => {
  const enableFullScreen = () => {
    const element = document.documentElement;
    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if (element.mozRequestFullScreen) {
      element.mozRequestFullScreen();
    } else if (element.webkitRequestFullscreen) {
      element.webkitRequestFullscreen();
    } else if (element.msRequestFullscreen) {
      element.msRequestFullscreen();
    }
  };

  const [invalidEmail, setInvalidEmail] = useState(false);
  const [invalidName, setInvalidName] = useState(false);

  const [uid, setUid] = useState("");
  const handleUidFromChild = (uidValue) => {
    setUid(uidValue);
    setReferenceNumber(uidValue);
    // saveOneTicket(null, uidValue);
    localStorage.setItem("uid", uidValue);
    // console.log("UID passed to ReferenceNumber", uidValue);
    // console.log("Firstname: ", Firstname);
    // console.log("Email: ", email);
  };
  const [openPopup, setOpenPopup] = useState(false);
  const [Firstname, setFirstname] = useState("");
  const [email, setEmail] = useState("");
  const [referenceNumber, setReferenceNumber] = useState("");
  const [mobile, setMobile] = useState("");
  const [showThanks, setShowThanks] = useState(false);

  const saveOneTicket = async (e, uid) => {
    if (e) e.preventDefault(); // Prevent the default form submission behavior
    console.log("Saving details...");

    const ticketDetails = {
      Firstname,
      Email: email,
      mobile,
      Reference_Number: uid || referenceNumber,
      gameZone1: 0,
      gameZone2: 0,
      gameZone3: 0,
      gameZone4: 0,
      merchCollected: false,
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_ADMIN}/qrCode/generateOneRfid`,
        ticketDetails
      );

      const savedDetails = response.data;
      setShowThanks(true);

      setTimeout(() => {
        setShowThanks(false);
      }, 3000);

      // Display success toast message
      toast(savedDetails?.mssg || "Details saved successfully!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        fontFamily: `"Trade Gothic Extended", sans-serif`,
        theme: "light",
      });

      // Clear form inputs after a short delay
      setTimeout(() => {
        setReferenceNumber("");
        setEmail("");
        setFirstname("");
        setMobile("");
      }, 1500);
    } catch (error) {
      // Handle errors
      toast.error("Failed to save details. Please try again.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        fontFamily: `"Trade Gothic Extended", sans-serif`,
        progress: undefined,
        theme: "light",
      });
      console.error("Error saving details:", error);
    }
  };

  function validateEmail(email) {
    var emailFilter =
      /^([a-zA-Z0-9_.'-])+@(([a-zA-Z0-9-])+.)+([a-zA-Z0-9]{2,4})+$/;
    if (!emailFilter.test(email)) {
      setInvalidEmail(true);
      return false;
    }
    if(!Firstname){
      setInvalidName(true);
      return false;
    }
    setInvalidName(false);
    setInvalidEmail(false);
    return true;
  }

  useEffect(() => {
    // enableFullScreen();
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <div style={styles.container}>
        <ToastContainer />
        {!showThanks && (
          <Card style={styles.card}>
            <CardContent>
              <form style={styles.form} onSubmit={saveOneTicket}>
                <TextField
                  label="Full Name"
                  value={Firstname}
                  onChange={(e) => setFirstname(e.target.value)}
                  variant="outlined"
                  type="text"
                  required
                  margin="normal"
                  fullWidth
                />
                {invalidName && (
                  <label
                    style={{
                      color: "pink",
                      fontSize: "0.8rem",
                      marginLeft: "5%",
                    }}
                  >
                    Please enter valid name
                  </label>
                )}
                <TextField
                  label="Email"
                  type="email"
                  required
                  onChange={(e) => {
                    // console.log(e.target.value);
                    setEmail(e.target.value);
                  }}
                  value={email}
                  variant="outlined"
                  margin="normal"
                  fullWidth
                />
                {invalidEmail && (
                  <label
                    style={{
                      color: "pink",
                      fontSize: "0.8rem",
                      marginLeft: "5%",
                    }}
                  >
                    Please enter valid email
                  </label>
                )}
                {/* <TextField
    autoFocus
    value={referenceNumber}
    label="UID"
    onChange={(e) => setReferenceNumber(e.target.value)}
    required
    type="text"
    margin="normal"
    fullWidth
  /> */}
                {/* <Typography variant="h5" style={styles.heading} marginTop={10}>
      Let the new games begin
    </Typography> */}
                <Button
                  variant="contained"
                  type="button"
                  style={styles.button}
                  onClick={() => {
                    if (validateEmail(email)) {
                      setOpenPopup(true);
                    }
                  }}
                >
                  Proceed
                </Button>
              </form>
            </CardContent>
          </Card>
        )}
        {/* {openPopup && <TermsAndConditionsPopup setOpenPopup={setOpenPopup} />} */}
        {openPopup && (
          <TermsAndConditionsPopup
            setOpenPopup={setOpenPopup}
            handleUidFromChild={handleUidFromChild}
            saveOneTicket={saveOneTicket}
          />
        )}

        {showThanks && (
          <img
            src={thankYouImage}
            width="100%"
            style={{
              zIndex: "99999",
              height: "100vh",
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
            }}
          />
        )}
      </div>
    </ThemeProvider>
  );
};

const TermsAndConditionsPopup = ({
  setOpenPopup,
  handleUidFromChild,
  saveOneTicket,
}) => {
  const [validUID, setValidUID] = useState(false);
  const [uid, setUid] = useState("");
  // console.log("before disclaimer");
  // console.log("Disclaimer JSON:", disclaimer);

  const handleAgree = () => {
    if (!uid) {
      setValidUID(true);
      return false;
    }
    setValidUID(false);
    handleUidFromChild(uid);
    setOpenPopup(false);
    console.log("UID:", uid);
    // saveOneTicket({ preventDefault: () => {} });
    saveOneTicket(null, uid);
  };

  return (
    <Dialog
      open={true}
      onClose={() => setOpenPopup(false)}
      maxWidth="md"
      fullWidth
    >
      <DialogContent style={popupStyles.popup}>
        {/* <Typography variant="h6" style={{ fontSize: "18px" }}>
          Terms and Conditions
        </Typography> */}
        <h1
          style={{
            textAlign: "center",
            margin: "5% 0",
          }}
        >
          Terms and Conditions
        </h1>
        <div
          style={{
            // background:"red",
            marginBottom: "2%",
            overflowY: "auto",
            maxHeight: "700px",
            marginTop: "20px",
            scrollbarWidth: "none",
            overflowX: "hidden",
            wordWrap: "break-word",
            paddingRight: "3%",
          }}
        >
          {/* <pre style={{ color: "white" }}>
            {disclaimer ? disclaimer : 'No terms and conditions available.'}
          </pre> */}

          <TermsAndConditions />
        </div>
        <br />

        <TextField
          autoFocus
          value={uid}
          label="Unique ID"
          onChange={(e) => {
            setUid(e.target.value);
          }}
          required
          type="text"
          margin="normal"
          inputProps={{ inputMode: "none" }}
          fullWidth
        />
        {validUID && (
          <label
            style={{
              color: "pink",
              fontSize: "1rem",
              marginLeft: "1%",
              marginBottom: "5%",
            }}
          >
            {uid == "" ? "Tap the RFID band" : ""}
          </label>
        )}
        <br />

        <Button
          variant="contained"
          style={popupStyles.button}
          onClick={handleAgree}
        >
          I Agree
        </Button>
      </DialogContent>
    </Dialog>
  );
};

const TermsAndConditions = () => {
  const styles = {
    disclaimerContainer: {
      textAlign: "justify",
      lineHeight: "1.5",
    },
    header: {
      textAlign: "center",
      marginBottom: "5%",
      marginTop: "8%",
    },

    ol: {
      paddingLeft: "4%",
    },
  };

  return (
    <div style={styles.disclaimerContainer}>
      <ol style={styles.ol}>
        <li>
          Entry into the Squid Game activation space is at the sole discretion
          of the Organiser(s).
        </li>

        <li>
          By processing entry to the Squid Game activation space, either
          directly or through the parent or guardian, the Attendee(s)
          acknowledge and agree to abide by the Organiser’s:
          <ul>
            <li>(i) Terms and Conditions</li>
            <li>(ii) Waiver And Release Of Liability Form</li>
          </ul>
        </li>

        <li>
          All participants allowed into the Squid Game activation space must
          register themselves at the entryway and wear the wristbands given.
        </li>

        <li>
          Each wristband entitles entry for 1 person for 1 time only. Wristbands
          are not valid for multiple entries.
        </li>

        <li>
          Damaged, tampered, torn, and removed wristbands will not be replaced,
          and entry may be denied in case of any misuse.
        </li>

        <li>
          Organiser(s) reserve the right to reserve, withdraw, and/or cancel
          admission without any prior notice.
        </li>

        <li>
          The personal information of Attendee(s) supplied to the Organiser(s)
          at the time of participation is securely stored by the Organiser(s) as
          confidential information. The Organisers assure the Attendees that the
          personal information shall not be shared, exchanged, or exploited for
          commercial gain. However, access to such information shall be
          restricted for internal analysis and assessment by the Organisers and
          used for future communications.
        </li>

        <li>
          The Attendee(s) may be videographed, filmed, photographed, and/or
          recorded for broadcast, publication, advertisement, marketing, or
          security purposes whilst at the Event by the Organiser(s) or by the
          Organiser(s), sponsors, and partners. The Attendee(s) hereby grant to
          the Organiser(s) the right to use in perpetuity, all or any part of
          the recording including but not limited to videos, films, photographs,
          and/or recordings of the Attendee(s) on any channel including social
          media channels globally for broadcasting, advertising, marketing,
          publicity, and promotions.
        </li>

        <li>
          Outside food, aerated, and alcoholic beverages are not allowed inside
          the Squid Game activation space.
        </li>

        <li>
          The Organiser(s) or any of its agents, officers, or employees will not
          be responsible for any injury, damage, theft, losses, or costs
          suffered by the Attendee(s) at the Squid Game activation space.
        </li>

        <li>
          Medical Requirements:
          <ul>
            <li>
              The Attendee(s) are advised to take all necessary precautions
              during the Event. The Organiser(s) assumes no liability if
              Attendee(s) suffers any medical condition while attending the
              Event.
            </li>
            <li>
              The Organiser(s) will not be responsible for any
              ill/harmful/negative/allergic effects of food items or drinks
              consumed at the Event by the Attendee(s).
            </li>
          </ul>
        </li>

        <li>
          The Attendee(s) will not be allowed entry at the Squid Game activation
          space if found in an inebriated state. The Organiser(s) reserves the
          right to evict such Attendee(s) from the arena who are under the
          influence of drugs or excessive alcohol or who, in the reasonable
          opinion of the Organiser(s), conducts themselves in an inappropriate
          manner.
        </li>

        <li>
          No dangerous or potentially hazardous objects including but not
          limited to weapons, knives, guns, firearms, fireworks, laser devices,
          glass bottles licensed or otherwise will be allowed in the Squid Game
          activation space and patrons may be asked to leave if found to be
          carrying any such items.
        </li>

        <li>
          Vape pens, e-cigarettes, cigarettes, lighters, and any other smoking
          devices are prohibited at the Event. The Organiser(s), at its sole
          discretion, will confiscate and dispose of any such prohibited items
          as and when found at the Event.
        </li>

        <li>
          Consumption and sale of illegal and banned substances is strictly
          prohibited, and anyone found consuming, selling, or possessing such
          illegal substances will be immediately handed over to the appropriate
          authorities.
        </li>

        <li>
          Attendee(s) will be given one chance per game. Re-tries (if any) are
          at the sole discretion of the Organiser(s) and are not binding.
        </li>

        <li>
          Swag distribution is at the sole discretion of the Organiser(s).
        </li>

        <li>
          The Organiser(s) reserves the right to change or cancel any part or
          the full program, function, display, activity lineup, games,
          promotions, scheme, announced or unannounced, before or during the
          Festival Venue without giving prior notice.
        </li>

        <li>
          The Organiser(s) reserves the right to conduct security searches at
          entry or at any time during the Event and confiscate any item which
          may cause danger or disruption to other persons or the event or is one
          of the items not permitted in the venue as listed in these Terms and
          Conditions.
        </li>

        <li>
          The Attendee(s) shall not bring into the Squid Game Activation space
          or display or distribute (whether for free or otherwise) during the
          event any sponsorship, promotional, or marketing materials.
        </li>

        <li>
          Attendee(s) are advised not to hand over any belongings to the
          Organizer representatives/crew under any circumstances, and
          Organiser(s) will not be responsible for loss or damage to personal
          effects.
        </li>

        <li>
          The Organiser(s) reserves the right to ask the Attendee(s) to exit
          from the Squid Game activation space if the Attendee(s) is not
          following the safety guidelines of the Event, on grounds of
          misdemeanour, any other medical safety reasons, or breach of these
          Terms, etc.
        </li>

        <li>
          All the Attendee(s) at the Event will be required to ensure that they
          cooperate with the Organiser(s)’s team at the Event in an ethical and
          polite way.
        </li>

        <li>The Attendee(s) will not be allowed to bring pets to the Event.</li>

        <li>
          The Attendee(s) are not allowed to bring any backpacks, big bags, or
          storage items to the Event. The Organiser(s) does not provide any
          storage facility at the Event Venue.
        </li>
      </ol>
    </div>
  );
};

export { Register, TermsAndConditionsPopup, TermsAndConditions };
